import { render } from "./UserStoriesSection.vue?vue&type=template&id=5e8ab65b&scoped=true"
import script from "./UserStoriesSection.vue?vue&type=script&lang=js"
export * from "./UserStoriesSection.vue?vue&type=script&lang=js"

import "./UserStoriesSection.vue?vue&type=style&index=0&id=5e8ab65b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8ab65b"]])

export default __exports__